import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { InputLayoutIcon, useFilterContext } from 'ui-builder';
import { PeopleFilter } from 'nekst-api';
import TextLayout from '../../shared/uibuilder/form/input/layout/TextLayout';
import styles from './PeopleListPage.module.scss';

export default function PersonNameFilter() {
  const filterContext = useFilterContext<PeopleFilter>();

  const [value, setValue] = useState<string | undefined>(filterContext.filterValue?.nameContains);

  const updateFilter = useCallback(
    debounce((text: string | undefined) => filterContext.setFilterValue({
      ...filterContext.filterValue!,
      nameContains: text,
    }), 500),
    [
      JSON.stringify(filterContext.filterValue),
    ],
  );

  useEffect(() => {
    updateFilter(value);
  }, [value]);

  return (
    <TextLayout
      value={value || ''}
      name="nameFilter"
      onChangeCallback={(event) => {
        setValue(event.target.value);
      }}
      isVisible
      placeholder="Search Contact"
      isDisabled={false}
      icon={InputLayoutIcon.SEARCH}
      className={styles.nameFilter}
      hideLabel
    />
  );
}
